// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelForm-Header_cls1__J1sfm","cls2":"PaymentChannelForm-Header_cls2__3fUQv PaymentChannelForm-Header_cls1__J1sfm"};